<script setup>
import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import FooterSocials from "@/Components/Footer/FooterSocials.vue";
import FooterNewsLetter from "@/Components/Footer/FooterNewsLetter.vue";
import IdealIcon from "@i/ideal.svg?component";
import FooterLinks from "@/Components/Footer/FooterLinks.vue";
import FooterCopyright from "@/Components/Footer/FooterCopyright.vue";
import logoRed from "@i/logo-red.svg";

const pagesLinks = computed(() => usePage().props.menus.find((header) => header.name === "pages"));
const footerProductLinks = computed(() => usePage().props.menus.find((header) => header.name === "footer_products"));
const serviceLinks = computed(() => usePage().props.menus.find((header) => header.name === "service"));
const companyDetails = computed(() => usePage().props.company_details);
</script>

<template>
    <div class="relative mt-auto bg-grey-dark text-sm text-white">
        <div class="outer-container mb-8 mt-15 gap-x-15 md:pt-30 lg:grid lg:grid-cols-3">
            <div class="w-full lg:col-span-1">
                <FooterNewsLetter />
                <FooterSocials class="mt-8 w-full lg:hidden" />
            </div>
            <div class="col-span-2 gap-7 lg:grid lg:grid-cols-4">
                <FooterLinks
                    :title="$t('Pages')"
                    :items="pagesLinks"
                />
                <FooterLinks
                    :title="$t('Products')"
                    :items="footerProductLinks"
                />
                <FooterLinks
                    :title="$t('Service')"
                    :items="serviceLinks"
                />
                <div>
                    <div class="md:text-md mb-4 mt-8 flex flex-col font-bold uppercase md:mt-0">
                        <h3>
                            {{ $t('Contact') }}
                        </h3>

                        <div class="2d:my-1 mt-1 h-px w-full bg-white" />
                    </div>
                    <ul class="space-y-2">
                        <li> {{ companyDetails.street }}</li>
                        <li> {{ companyDetails.postal_code }} {{ companyDetails.city }}</li>
                        <li>&nbsp;</li>
                        <li>
                            <a
                                :href="`tel:${companyDetails.phone_number}`"
                                class="underline-offset-4 hover:underline"
                            >
                                {{ companyDetails.phone_number }}
                            </a>
                        </li>
                        <li>
                            <a
                                :href="`mailto:${companyDetails.email_address}`"
                                class="underline-offset-4 hover:underline"
                            >
                                {{ companyDetails.email_address }}
                            </a>
                        </li>
                        <li>&nbsp;</li>
                        <li v-if="companyDetails.coc_number">
                            {{ $t('Coc:') }} {{ companyDetails.coc_number }}
                        </li>
                        <li v-if="companyDetails.vat_number">
                            {{ $t('VAT:') }} {{ companyDetails.vat_number }}
                        </li>
                    </ul>
                </div>
            </div>


            <div class="col-span-full mt-10 hidden flex-col justify-between gap-10 sm:flex-row sm:items-end lg:flex">
                <div>
                    <FooterSocials />
                </div>

                <div class="hidden justify-center md:flex">
                    <IdealIcon />
                </div>
            </div>
            <div class="flex-center col-span-full">
                <img
                    class="mt-10 w-30 lg:w-40"
                    :src="logoRed"
                    alt="firstnutrition"
                >
            </div>
        </div>
        <FooterCopyright />
    </div>
</template>
